module.exports = "/images/veil-10.jpg";